var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticClass:"text-center",staticStyle:{"height":"100vh"},attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('span',{staticClass:"headline"},[_vm._v(" 404 - Pagina no encontrada ")]),_c('v-btn',{attrs:{"text":"","color":"primary","to":"/"}},[_vm._v("Ir al inicio")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }